import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';

export class StudentService {

  constructor() { }

  fakeData = {
    'students': [
      { 'number': 1, 'name': 'Akash A', 'admissionNumber': 'Addmission Number', 'rolleNumber': 'Rolle Number' },
      { 'number': 2, 'name': 'Akash A 1', 'admissionNumber': 'Addmission Number', 'rolleNumber': 'Rolle Number' },
      { 'number': 3, 'name': 'Akash A 2', 'admissionNumber': 'Addmission Number', 'rolleNumber': 'Rolle Number' },
      { 'number': 4, 'name': 'Akash A 3', 'admissionNumber': 'Addmission Number', 'rolleNumber': 'Rolle Number' },
      { 'number': 5, 'name': 'Akash A 4', 'admissionNumber': 'Addmission Number', 'rolleNumber': 'Rolle Number' },
      { 'number': 6, 'name': 'Akash A 5', 'admissionNumber': 'Addmission Number', 'rolleNumber': 'Rolle Number' },
      { 'number': 7, 'name': 'Akash A 6', 'admissionNumber': 'Addmission Number', 'rolleNumber': 'Rolle Number' }
    ],
    'intake': 25,
    'accupied': 60,
    'location': 'B1-F1'
  };

  getStudents() {
    return this.fakeData;
  }
}
